import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';
import InputFilterItem from '../../../delivery/components/InputFilterItem';
import { useFilterContainerClassName, useFilterLabelClassName, useFilterInputContainerClassName } from '../../../../utils/languageUtils';

export type HandoverCarrierFilterOptions = {
  carrierName: string;
  contactName: string;
  status: number | null;
  carrierType: number | null;
};

export const DEFAULT_HANDOVER_CARRIER_FILTER_OPTIONS: HandoverCarrierFilterOptions = {
  carrierName: '',
  contactName: '',
  status: null,
  carrierType: null,
};

interface FilterAreaProps {
  filters: HandoverCarrierFilterOptions;
  setFilters: (filters: HandoverCarrierFilterOptions) => void;
}

const FilterArea: React.FC<FilterAreaProps> = ({ filters, setFilters }) => {
  const { t } = useTranslation();
  const containerClassName = useFilterContainerClassName();
  const labelClassName = useFilterLabelClassName();
  const inputContainerClassName = useFilterInputContainerClassName();

  return (
    <div className="mb-2 py-2">
      <div className="grid grid-cols-3 gap-x-10 gap-y-4 items-start">
        <div className="min-w-0">
          <InputFilterItem
            label={t('central.handoverCarrier.pageDetails.carrierName')}
            value={filters.carrierName}
            onChange={(e) => setFilters({ ...filters, carrierName: e.target.value })}
            spanClassName="!mr-3 !w-[64px] !min-w-0 !flex-shrink-0"
          />
        </div>
        <div className="min-w-0">
          <InputFilterItem
            label={t('central.handoverCarrier.pageDetails.contactName')}
            value={filters.contactName}
            onChange={(e) => setFilters({ ...filters, contactName: e.target.value })}
            spanClassName="!mr-3 !w-[48px] !min-w-0 !flex-shrink-0"
          />
        </div>
        <div className="min-w-0">
          <div className={containerClassName}>
            <span className={`${labelClassName} !mr-3 !w-[48px] !min-w-0 !flex-shrink-0`}>
              {t('central.handoverCarrier.pageDetails.status')}
            </span>
            <div className={inputContainerClassName}>
              <Select
                allowClear
                placeholder={String(t('components.input.all'))}
                className="w-full"
                size="middle"
                value={filters.status ?? undefined}
                onChange={(value) => setFilters({ ...filters, status: value ?? null })}
                options={[
                  { value: 1, label: t('enum.activeStatus.active') },
                  { value: 0, label: t('enum.activeStatus.suspended') },
                ]}
              />
            </div>
          </div>
        </div>
        <div className="min-w-0">
          <div className={containerClassName}>
            <span className={`${labelClassName} !mr-3 !w-[64px] !min-w-0 !flex-shrink-0`}>
              {t('central.handoverCarrier.pageDetails.carrierType')}
            </span>
            <div className={inputContainerClassName}>
              <Select
                allowClear
                placeholder={String(t('components.input.all'))}
                className="w-full"
                size="middle"
                value={filters.carrierType ?? undefined}
                onChange={(value) => setFilters({ ...filters, carrierType: value ?? null })}
                options={[
                  { value: 1, label: t('central.handoverCarrier.types.localLastMile') },
                  { value: 2, label: t('central.handoverCarrier.types.linehaul') },
                ]}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterArea;
